<template>
  <div class='home'>
    <WoTermList
      v-show='listView'
      @newWoTerm='onClickNewFromList'
      @editWoTerm='onClickEditFromList'
      :scroll="corY" ref='refreshList'
    />
    <WoTermForm
      v-show='formView'
      :woTerm='woTerm'
      @backClicked='onBackChild'
    />
  </div>
</template>

<script>
// @ is an alias to /src
import WoTermList from '@/components/wo-term/WoTermList.vue'
import WoTermForm from '@/components/wo-term/WoTermForm.vue'

export default {
  name: 'WoTerm',
  components: {
    WoTermList,
    WoTermForm
  },
  data () {
    return {
      corX: 0,
      corY: 0,
      listView: true,
      formView: false,
      woTerm: {
        id: null,
        name: null,
        category_id: null
      }
    }
  },
  methods: {
    onClickEditFromList: function (value) {
      var x = window.pageXOffset
      var y = window.pageYOffset
      this.corX = x
      this.corY = y
      window.scrollTo(0, 0)
      this.listView = false
      this.formView = true
      console.log(value)
      this.woTerm = value
    },
    onClickNewFromList: function () {
      var x = window.pageXOffset
      var y = window.pageYOffset
      this.corX = x
      this.corY = y
      window.scrollTo(0, 0)
      this.listView = false
      this.formView = true
      this.woTerm = {
        id: null,
        name: null,
        category: null
      }
    },
    async onBackChild () {
      window.scrollTo(this.corX, this.corY)
      this.listView = true
      this.formView = false
      this.woTerm = {
        id: null,
        name: null,
        category_id: null
      }
      await this.$refs.refreshList.refreshList()
      await window.scrollTo(this.corX, this.corY)
      console.log('window.scrollTo:' + this.corY)
    }
  },
  mounted () {
    this.$store.dispatch('getWoTermCategoryList')
  }
}
</script>
